import Popover from 'src/components/popover/popover.vue'

import { useStatusesStore } from 'src/stores/statuses.js'

import { openPost } from 'src/services/post_link/post_link.js'

const StatusPopover = {
  name: 'StatusPopover',
  // offset: { x, y } px away from the trigger, or from the element
  // matching anchorSelector (inside the trigger or around it)
  props: ['statusId', 'offset', 'anchorSelector'],
  data() {
    return {
      error: false,
    }
  },
  computed: {
    status() {
      return useStatusesStore().allStatuses.get(this.statusId)
    },
  },
  components: {
    Popover,
  },
  methods: {
    open(event) {
      if (openPost(event, this.$router, this.statusId)) {
        this.$refs.popover.hidePopover()
      }
    },
    enter() {
      if (!this.status) {
        if (!this.statusId) {
          this.error = true
          return
        }
        useStatusesStore()
          .fetchStatus(this.statusId)
          .then(() => (this.error = false))
          .catch(() => (this.error = true))
      }
    },
  },
  watch: {
    status(newStatus, oldStatus) {
      if (newStatus !== oldStatus) {
        this.$nextTick(() => this.$refs.popover.updateStyles())
      }
    },
  },
}

export default StatusPopover
